import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tablet",
  "use": "tablet-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"tablet\">\n<path d=\"M23,6v12c0,1.7-1.3,3-3,3H4c-1.7,0-3-1.3-3-3V6c0-1.7,1.3-3,3-3h16C21.7,3,23,4.3,23,6z M3,18c0,0.6,0.4,1,1,1h16\n\tc0.6,0,1-0.4,1-1V6c0-0.6-0.4-1-1-1H4C3.4,5,3,5.4,3,6V18z\" />\n<path d=\"M13,8c0,0.6-0.4,1-1,1s-1-0.4-1-1v0c0-0.6,0.4-1,1-1S13,7.4,13,8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol